export enum ContentTags {
  CONFIGURATION = "configuration",
  DEVICE = "device",
  LOGS = "logs",
}
